import React from "react";
import {
  FundsAccountAutocomplete,
  FundsAccountAutocompleteProps,
} from "@components/FundsAccount/FundsAccountAutocomplete/FundsAccountAutocomplete";
import { useAutocompleteToFundsAccountsQuery } from "@apollo/ops";

export function ToFundsAccountAutocomplete(
  props: Omit<FundsAccountAutocompleteProps, "fundsAccounts">
) {
  const { data } = useAutocompleteToFundsAccountsQuery();

  if (!data) {
    return <div className="h-36" />;
  }

  return (
    <FundsAccountAutocomplete
      fundsAccounts={data.fundsAccountsEligibleToReceive}
      {...props}
    />
  );
}
